import { useContext } from "react";
import { Redirect, useLocation, useRouteMatch } from "react-router";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";
import { UserInfoContext } from "helpers/globalContext/UserInfoContext";

import { routes } from "utilities/routes";

const RedirectToSetupSummary = () => {
    const match = useRouteMatch();
    const location = useLocation();

    const userContext = useContext(UserInfoContext);
    const builderInfoContext = useContext(BuilderInfoContext);
    // If the user is trying to get to the subscription manager or frozen page, we don't want to redirect them to the setup experience
    const isSubscriptionRoute = match.path === routes.subscriptionManager.settings;
    // If the user is trying to connect to accounting through the gated setup app/setup page, don't want to redirect. OAuthRedirect.tsx will handle the redirect
    const isAccountingRedirectRoute = location.pathname === routes.accounting.oAuthRedirect;
    // If the user is trying to onboard to payments, don't redirect. They will be redirected back after completing onboarding.
    const isPaymentsOnboarding =
        location.pathname === routes.onlinePayments.paymentsHostedOnboarding;
    const isAddNewPaymentMethodRoute =
        location.pathname ===
        routes.onlinePayments.paymentsHostedOnboarding +
            routes.onlinePayments.paymentServicePaymentMethod.newPaymentMethodPath;
    // If the user is uploading documents requested post-payments-signup, allow access so they can complete the task from the email link.
    const isFinancialDocumentCollection =
        location.pathname === routes.onlinePayments.financialDocumentCollection;

    // Don't redirect if the user is already on the setup route
    const isSetupRoute = match.path === routes.builderSetup.setup;

    if (
        userContext?.shouldRedirectToSetupExperience &&
        !isSubscriptionRoute &&
        !isAccountingRedirectRoute &&
        !isSetupRoute &&
        !isPaymentsOnboarding &&
        !isAddNewPaymentMethodRoute &&
        !isFinancialDocumentCollection &&
        !builderInfoContext?.loginsDisabled
    ) {
        return <Redirect to={routes.builderSetup.setup} />;
    }
    return null;
};

export default RedirectToSetupSummary;
